'use strict';
//todo: change slider and popup with bootstrap

import Analytics from '../../_common/js/modules/analytics';
import analyticsEvents from '../../_common/js/modules/analyticsEvents';
import announcementBar from '../../_common/js/modules/announcement';
import popupButtons from './modules/popupButtons';
import compare from './modules/compare-images';
import Cookies from '../../_common/js/modules/cookies';
import imageWrapper from '../../_common/js/modules/imageWrapper';
import intlPhoneInput from '../../_common/js/modules/intlPhoneInput';
import mediumZoom from '../../_common/js/modules/mediumZoom';
import modalPopupBox from './modules/modalPopupBox';
import pricing from './modules/pricing';
import calendlyAnalytics from './modules/calendlyAnalytics';
import stickyMainMenu from '../../_common/js/modules/stickyMainMenu';
import userParams from '../../_common/js/modules/userParams';
import contactForm from '../../_common/js/modules/contactForm';
import gdprCookie from '../../_common/js/modules/gdprCookie';
import mobileMenu from '../../_common/js/modules/mobileMenu';
import modalWindow from '../../_common/js/modules/modalWindow';
import pricingList from './modules/pricingList';
import popupBanner from './modules/popupBanner';
import videoGuides from '../../_common/js/modules/videoGuides';
// new
import animationNumber from './modules/animationNumbers';
import buttonHeader from './modules/buttonForHeader';
import cycleTabs from './modules/cycleTabs';
import counter from './modules/counter';
import zendeskForm from './modules/zendeskRequestForm';
import { initNavbarScroll } from './modules/scrollHandler';
import initPricingSelector from './modules/pricing-selector';
import themeSearch from './modules/themeSearch';
import { initVideoRowSliders } from './modules/videoSlider';
import { initVideoPagination } from './modules/videoPagination';

( function( document, window ) {
    const analytics = Analytics();
    const cookiesGeneral = Cookies( 'HDM' );
    const isGuide = document.querySelector( '.et-sn' );

    // Ready
    document.addEventListener( 'DOMContentLoaded', function() {
        mediumZoom();

        const zoomWrap = document.querySelector( '.zoom-default:not([hidden]' );
        if ( zoomWrap ) {
            imageWrapper();
        }

        if ( ! isGuide ) {
            stickyMainMenu();
        }

        const navMobile = document.querySelector( '*[data-bs-target="#navbarMobileMainMenu"]' );
        if ( navMobile ) {
            mobileMenu();
        }

        const phoneInputs = document.querySelectorAll( 'input[type=tel]' );
        if ( phoneInputs.length ) {
            intlPhoneInput( phoneInputs );
        }

        const chatBtn = document.querySelector( '.zendesk-btn' );
        const calendlyBtn = document.querySelector( '.calendly-btn' );
        if ( chatBtn || calendlyBtn ) {
            popupButtons();
        }

        userParams( cookiesGeneral );

        const imgCompare = document.querySelector( '.img-comp-container:not([hidden])' );
        if ( imgCompare ) {
            compare();
        }

        const announcementBarElement = document.querySelector( '.announcement-bar' );
        if ( announcementBarElement ) {
            announcementBar( cookiesGeneral, announcementBarElement );
        }

        const gdprCookieElement = document.getElementById( 'tuna_gdpr__cookie' );
        if ( gdprCookieElement && ! isGuide ) {
            gdprCookie( cookiesGeneral, gdprCookieElement );
        }

        const modalVideoItem = document.querySelector( '#modalVideo' );
        if ( modalVideoItem ) {
            modalWindow();
        }

        // change only bootstrap 5
        const modalPopupElement = document.getElementById( 'modalPopupBox' );
        if ( modalPopupElement ) {
            modalPopupBox( cookiesGeneral, modalPopupElement );
        }

        const wpcf7Form = document.querySelector( '.wpcf7-form' );
        if ( wpcf7Form ) {
            contactForm();
        }

        const templateFormContainer = document.querySelector( '.template-form' );
        if ( templateFormContainer ) {
            const form = templateFormContainer.querySelector( '.wpcf7-form' );
            if ( form ) {
                zendeskForm();
            }
        }

        const pricingForm = document.querySelector( '.pricing-form' );
        if ( pricingForm ) {
            pricing();
        }

        const pricingListBtn = document.querySelector( '.button-show-all-items' );
        if ( pricingListBtn ) {
            pricingList();
        }

        const pricingSelector = document.querySelector( '.pricing-selector' );
        if ( pricingSelector ) {
            initPricingSelector();
        }

        const popupBannerElement = document.getElementById( 'popup-banner' );
        if ( popupBannerElement ) {
            const bannerCookieName = popupBannerElement.getAttribute( 'data-cookie-name' );
            const cookieName = document.cookie.split( '; ' ).find( ( row ) => row.startsWith( bannerCookieName + '=false' ) );
            if ( typeof cookieName === 'undefined' || popupBannerElement.getAttribute( 'data-banner-cookie' ) === 'false' ) {
                popupBanner();
            }
        }

        const counterDown = document.getElementById( 'theme-counter' );
        if ( counterDown ) {
            counter();
        }


        const switchPrice = document.querySelector( '.switch-price' );
        if ( switchPrice ) {
            const switchPriceCheckbox = document.querySelectorAll( '.switch-price input[type=checkbox]' );
            switchPriceCheckbox.forEach( ( checkbox ) => checkbox.addEventListener( 'change', function() {
                this.closest( '.d-flex' ).nextElementSibling.querySelectorAll(
                    '.price-card-sub-price.month,' +
                    '.price-card-sub-price.year,' +
                    '.price-card-price.month,' +
                    '.price-card-price.year'
                ).forEach( ( el ) => el.classList.toggle( 'd-none' ) );
            } ) );
        }

        const themeSearchForm = document.querySelector( '.search-form' );
        if ( themeSearchForm ) {
            themeSearch();
        }

        initVideoRowSliders();

        initVideoPagination();

        calendlyAnalytics( analytics );

        const submitForm = document.querySelector( '.wpcf7-submit' );
        if ( submitForm ) {
            document.addEventListener( 'wpcf7submit', function() {
                setTimeout( function() {
                    submitForm.disabled = false;
                }, 20 );
            }, false );
        }

        const eventBtns = document.querySelectorAll( '[data-ga-action]' );
        if ( eventBtns.length > 0 ) {
            analyticsEvents( analytics, eventBtns );
        }

        const videoGuidesBtn = document.querySelector( '.show-all-video-posts' );
        if ( videoGuidesBtn ) {
            videoGuides();
        }

        // NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW NEW

        // For Features Block GDPR Landing
        document.querySelectorAll( '.toggle-btn' ).forEach( ( button ) => {
            button.addEventListener( 'click', function() {
                document.querySelectorAll( '.accordion-body.show' ).forEach( ( body ) => {
                    body.style.height = 0;
                    body.classList.remove( 'show' );
                } );

                const accordionBody = this.closest( '.nav-item' ).querySelector( '.accordion-body' );

                if ( ! accordionBody.classList.contains( 'show' ) ) {
                    accordionBody.classList.add( 'show' );
                    accordionBody.style.height = accordionBody.scrollHeight + 'px';
                } else {
                    accordionBody.style.height = 0;
                    accordionBody.classList.remove( 'show' );
                }
            } );
        } );

        // add position-relative if page with landingMenu
        const landingMenu = document.getElementById( 'landingMenu' );
        const secondNavbar = document.querySelector( '.second-navbar' );
        if ( landingMenu && secondNavbar ) {
            secondNavbar.classList.add( 'position-relative' );
        }

        //show sub-menu in header main menu
        const productsItemBtns = document.querySelectorAll( '.products-item' );
        if ( productsItemBtns.length ) {
            productsItemBtns.forEach( ( elem ) => {
                elem.addEventListener( 'click', function( event ) {
                    event.stopPropagation();
                    document.querySelectorAll( '.show .products-item.active' ).forEach( ( el ) => el.classList.remove( 'active' ) );
                    this.classList.add( 'active' );
                } );
            } );
        }

        //animation for numbers
        const numberAnimationElements = document.querySelectorAll( '.number-animation' );
        if ( numberAnimationElements.length ) {
            animationNumber( numberAnimationElements );
        }

        // Mobile Menu
        const btnsSubMenu = document.querySelectorAll( '#navbarMobileMainMenu li.menu-item-has-children > a' );
        btnsSubMenu.forEach( ( btn ) => {
            btn.addEventListener( 'click', function( event ) {
                event.preventDefault();
                this.parentElement.classList.toggle( 'active' );
            } );
        } );

        // Show button in header mobile menu
        const buttonEl = document.getElementById( 'buttonForHeader' );
        if ( buttonEl ) {
            buttonHeader( buttonEl );
        }

        // Sticky header for landings
        if ( document.getElementById( 'landingMenu' ) || document.querySelector( '.second-main-wrapper' ) ) {
            initNavbarScroll();
        }

        // Show scrollButtons
        const showScrollButtons = document.getElementById( 'showScrollButtons' );
        const scrollButtons = document.getElementById( 'scrollButtons' );
        if ( showScrollButtons && scrollButtons ) {
            document.addEventListener( 'scroll', function() {
                const footerPosition = document.querySelector( '.theme--footer' ).offsetTop;
                const scrollPositionBottom = window.scrollY + ( window.innerHeight * 0.7 );

                if ( window.scrollY > showScrollButtons.offsetTop + showScrollButtons.offsetHeight && scrollPositionBottom < footerPosition ) {
                    scrollButtons.classList.add( 'show' );
                } else {
                    scrollButtons.classList.remove( 'show' );
                }
            } );
        }

        // Footer nav menu for mobile
        const footerMobileNavMenuTitle = document.querySelectorAll( '.widget_nav_menu > h6' );
        if ( footerMobileNavMenuTitle.length > 0 ) {
            footerMobileNavMenuTitle.forEach( ( elem ) => {
                elem.addEventListener( 'click', function() {
                    this.parentElement.classList.toggle( 'show' );
                } );
            } );
        }

        // Progress bar for UpChat landing
        const progressbarItems = document.querySelectorAll( '.progressbar.clicked li' );
        if ( progressbarItems.length ) {
            function handleScroll() {
                const rect = progressbarItems[ 0 ].getBoundingClientRect();

                if ( rect.top <= window.innerHeight && rect.bottom >= 0 ) {
                    let index = 1;
                    function addActiveClass() {
                        if ( index < progressbarItems.length ) {
                            progressbarItems[ index ].classList.add( 'active' );
                            index++;
                            setTimeout( addActiveClass, 2000 );
                        }
                    }
                    setTimeout( addActiveClass, 2000 );

                    window.removeEventListener( 'scroll', handleScroll );
                }
            }

            window.addEventListener( 'scroll', handleScroll );
        }

        // Copy link post to clipboard
        const copyLink = document.querySelector( '.copy-link' );
        if ( copyLink ) {
            copyLink.addEventListener( 'click', async ( event ) => {
                event.preventDefault();
                const url = copyLink.getAttribute( 'data-url' );
                const originalContent = copyLink.innerHTML;

                const setCopiedMessage = () => {
                    copyLink.textContent = 'Copied!';
                    console.log( 'URL copied to clipboard' );
                    setTimeout( () => {
                        copyLink.innerHTML = originalContent;
                    }, 3000 );
                };

                try {
                    if ( navigator.clipboard && navigator.clipboard.writeText ) {
                        await navigator.clipboard.writeText( url );
                        setCopiedMessage();
                    } else {
                        const textArea = document.createElement( 'textarea' );
                        textArea.value = url;
                        document.body.appendChild( textArea );
                        textArea.select();
                        document.execCommand( 'copy' );
                        document.body.removeChild( textArea );
                        setCopiedMessage();
                    }
                } catch ( err ) {
                    console.error( 'Failed to copy URL: ', err );
                }
            } );
        }

        // Horizontal scroll for category blog
        if ( document.querySelectorAll( '.scroll-btn' ).length ) {
            const categoryTabs = document.querySelector( '.category-tabs' );
            const leftBtn = document.getElementById( 'leftBtn' );
            const rightBtn = document.getElementById( 'rightBtn' );

            function updateButtons() {
                const scrollLeft = categoryTabs.scrollLeft;
                const scrollWidth = categoryTabs.scrollWidth;
                const clientWidth = categoryTabs.clientWidth;

                const hasScroll = scrollWidth > clientWidth;

                leftBtn.classList.toggle( 'd-none', ! hasScroll || scrollLeft === 0 );
                rightBtn.classList.toggle( 'd-none', ! hasScroll || scrollLeft >= scrollWidth - clientWidth - 1 );
            }

            leftBtn.addEventListener( 'click', () => {
                categoryTabs.scrollBy( { left: -500, behavior: 'smooth' } );
            } );

            rightBtn.addEventListener( 'click', () => {
                categoryTabs.scrollBy( { left: 500, behavior: 'smooth' } );
            } );

            categoryTabs.addEventListener( 'scroll', updateButtons );
            window.addEventListener( 'resize', updateButtons );

            updateButtons();
        }

        // initialization tooltip for BS
        if ( document.querySelectorAll( '[data-bs-toggle="tooltip"]' ).length ) {
            const tooltipTriggerList = document.querySelectorAll( '[data-bs-toggle="tooltip"]' );
            [ ...tooltipTriggerList ].map( ( tooltipTriggerEl ) => new bootstrap.Tooltip( tooltipTriggerEl ) );
        }

        // features block animation for AB testing
        const observeElement = ( selector, callback ) => {
            const targetElement = document.querySelector( selector );
            if ( ! targetElement ) {
                return;
            }

            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.2,
            };

            const observerCallback = ( entries, observer ) => {
                entries.forEach( ( entry ) => {
                    if ( entry.isIntersecting ) {
                        callback();
                        observer.disconnect();
                    }
                } );
            };

            const observer = new IntersectionObserver( observerCallback, observerOptions );
            observer.observe( targetElement );
        };

        observeElement( '.landing-tabs-animation', () => {
            document.querySelectorAll( '.landing-tabs-animation .nav.nav-tabs button' )
                .forEach( ( button ) => button.classList.add( 'active' ) );
            cycleTabs( '.landing-tabs-animation' );
        } );

        //switch product tabs automatically
        observeElement( '.product-tabs', () => {
            cycleTabs( '.product-tabs', 5000 );
        } );

        observeElement( '.theme-landing-tab', () => {
            document.querySelectorAll( '.theme-landing-tab .nav.nav-tabs button' )
                .forEach( ( button ) => button.classList.add( 'active' ) );
        } );
    }, false );
}( document, window ) );
